import { MemberService } from './../../Services/member.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-new-member-form-admin',
  template: require('./new-member-form-admin.component.html'),
  styles: [require('./new-member-form-admin.component.css')]
})
export class NewMemberFormAdminComponent implements OnInit {

  allNewSubscriptions: any[] = [];
  currentYear:number = (new Date()).getFullYear()
  constructor( private membersService: MemberService, private auth: AuthService ) { }


  ngOnInit() {
    this.loadAllNewMemberRequests();
  }

  loadAllNewMemberRequests(){
    this.membersService.getAllNewMemberRequests().subscribe( (res:any) => {
      this.allNewSubscriptions = res;
      // console.log(this.allNewSubscriptions);
    })
  }

  removeNewMemberRequest(id: number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze aanvraag wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.membersService.deleteNewMemberRequest(id).subscribe( (res:any)=>{
          this.loadAllNewMemberRequests();
        })
      }
    });
  }

  addNewMemberFromRequest(id: number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze aanvraag wil aanvaarden?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        var req = this.allNewSubscriptions.find( i => i.id == id );
          if (req){
            var member = {
              firstName: req.firstName,
              lastName: req.lastName,
              birthday: req.birthday,
              streetName: req.streetName,
              houseNr: req.houseNr,
              postalCode: req.postalCode,
              community: req.community,
              email: req.email,
              teleponeNr: req.telephoneNr,
              cellPhoneNr: req.cellPhoneNr,
              groupId: 1,
              hasPayedMemberShip: false,
              isExemptFromPayment: false,
              hasDeliveredSubscriptionSheet: true,
              isBaankapitein: false,
              isBestuur: false,
              isSiteAdmin: false,
              isEditor: false,
              iceContactNr: null,
              iceContactRelation: null,
              memberDiscountID: 2,
              iceComments: null,
              profileImage: null,
              gender: req.gender
            }
            this.membersService.create(member).subscribe( (res:any) => {
              console.log(res);
              if (res.status == 200){
                Swal.fire({
                  title: 'Aanvaard!',
                  type: 'success',
                  html:
                    'Het request is toegevoegt aan de ledenlijst' ,
                  showCloseButton: false,
                  showCancelButton: false,
                  focusConfirm: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  if (result.value) {
                    this.membersService.deleteNewMemberRequest(id).subscribe( (res:any)=>{
                      this.loadAllNewMemberRequests();
                    })
                  }
                })
              }
              
            })
          }
      }
      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/new-member-form-admin/new-member-form-admin.component.ts